export default __webpack_public_path__ + "static/media/PreviewDoorHanger.aab8e54b.png";